import React, { createContext, useContext, useEffect, useState } from "react";
import { loadModels, getState } from "@/lib/face";

const FaceContext = createContext({ status: "Idle", ready: false });

export function FaceProvider({ children }) {
  const [status, setStatus] = useState("Loading AI…");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    loadModels(setStatus)
      .then(() => { setReady(true); setStatus("AI Ready"); })
      .catch(() => { setReady(false); setStatus("Simulation Mode"); });
    // Watch state in case loaded elsewhere
    const i = setInterval(() => {
      const s = getState();
      if (s.ready && !ready) { setReady(true); setStatus("AI Ready"); }
    }, 1000);
    return () => clearInterval(i);
  }, [ready]);

  return (
    <FaceContext.Provider value={{ status, ready }}>{children}</FaceContext.Provider>
  );
}

export const useFace = () => useContext(FaceContext);
